import React from 'react';
import { attorneys } from '../mockData';
import { Card } from './ui/card';
import { Phone, Briefcase, GraduationCap, Calendar } from 'lucide-react';

export const AttorneysSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-[#58225a] mb-4">Our Attorneys</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Meet our experienced team of legal professionals dedicated to protecting your intellectual property.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {attorneys.map((attorney) => (
            <Card
              key={attorney.id}
              className="relative p-8 border-2 border-[#e8a8c8] shadow-xl overflow-hidden transition-all duration-300 hover:shadow-2xl hover:scale-105 hover:border-[#ba2a84]"
              style={{
                background: 'linear-gradient(135deg, #ba2a84 0%, #58225a 100%)',
                borderRadius: '2rem'
              }}
            >
              <div className="relative z-10">
                <div className="flex items-start justify-between mb-4">
                  <h3 className="text-2xl font-bold text-white">{attorney.name}</h3>
                  <div className="w-12 h-12 rounded-full bg-[#e8a8c8]/20 flex items-center justify-center">
                    <Briefcase className="h-6 w-6 text-[#e8a8c8]" />
                  </div>
                </div>
                
                {attorney.admitted && (
                  <div className="flex items-center gap-2 mb-3">
                    <Calendar className="h-4 w-4 text-[#e8a8c8]" />
                    <p className="text-white/90 text-sm">
                      <span className="font-semibold">Admitted:</span> {attorney.admitted}
                    </p>
                  </div>
                )}
                
                {attorney.school && (
                  <div className="flex items-center gap-2 mb-3">
                    <GraduationCap className="h-4 w-4 text-[#e8a8c8]" />
                    <p className="text-white/90 text-sm font-semibold">{attorney.school}</p>
                  </div>
                )}
                
                {attorney.firm && (
                  <p className="text-white/90 text-sm mb-4">
                    <span className="font-semibold">{attorney.firm}</span>
                    {attorney.location && <span className="ml-2 text-[#e8a8c8]">• {attorney.location}</span>}
                  </p>
                )}
                
                <div className="mt-4 mb-4">
                  <p className="text-[#e8a8c8] text-sm font-semibold mb-2">Specialties:</p>
                  <ul className="space-y-1">
                    {attorney.specialties.map((specialty, index) => (
                      <li key={index} className="text-white/80 text-sm flex items-start">
                        <span className="text-[#e8a8c8] mr-2">•</span>
                        {specialty}
                      </li>
                    ))}
                  </ul>
                </div>
                
                <div className="mt-4 pt-4 border-t border-white/30">
                  {attorney.barId && (
                    <p className="text-white/90 text-sm mb-2">
                      <span className="font-semibold text-[#e8a8c8]">Bar ID:</span> {attorney.barId}
                    </p>
                  )}
                  {/* {attorney.phone && (
                    <div className="flex items-center gap-2">
                      <Phone className="h-4 w-4 text-[#e8a8c8]" />
                      <p className="text-white/90 text-sm">
                        <span className="font-semibold">{attorney.phone}</span>
                      </p>
                    </div>
                  )} */}
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
